import DateSelectBox from '@/pages/policy/components/DateSelectBox';
import { privacySelectItem } from '@/pages/policy/constants';
import { useState } from 'react';
import Privacy250410 from '@/pages/policy/privacy/Privacy250410';
import Privacy250623 from '@/pages/policy/privacy/Privacy250623';

const privacy = () => {
	const [selectedDate, setSelectedDate] = useState<string>(privacySelectItem[0]?.text || ''); // 선택된 시행 일자

	return (
		<>
			<DateSelectBox selectItems={privacySelectItem} selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
			{selectedDate === privacySelectItem[0].text && <Privacy250623 />}
			{selectedDate === privacySelectItem[1].text && <Privacy250410 />}
		</>
	);
};

export default privacy;
